import api from './api'

/**
 * Login OTP direto nos devices: `nome.sobrenome` + código atual do autenticador da plataforma.
 * O device pergunta à nuvem a cada login (o segredo TOTP nunca sai da nuvem); cada código vale uma vez.
 */
export const deviceOtpApi = {
  status: async (deviceId) => (await api.get(`/managed-devices/${deviceId}/otp`)).data,
  /** Liga/desliga no device (Owner/Admin; pede MFA pelo interceptor). */
  setEnabled: async (deviceId, enabled) => (await api.put(`/managed-devices/${deviceId}/otp`, { enabled })).data,
  syncNow: async (deviceId) => (await api.post(`/managed-devices/${deviceId}/otp/sync`)).data,
  me: async () => (await api.get('/managed-device-auth/me')).data,
}

export const OTP_SYNC_META = {
  ok: { label: 'Aplicado', cls: 'bg-green-100 text-green-800' },
  pending: { label: 'Aplicando…', cls: 'bg-amber-50 text-amber-700' },
  removing: { label: 'Removendo…', cls: 'bg-amber-50 text-amber-700' },
  error: { label: 'Erro', cls: 'bg-red-100 text-red-800' },
  off: { label: 'Desligado', cls: 'bg-gray-100 text-gray-600' },
}

export const OTP_REASON_LABEL = {
  ok: 'ok',
  'invalid-code': 'código inválido ou já usado',
  'unknown-user': 'login desconhecido',
  'not-allowed': 'sem permissão no device',
  'mfa-disabled': 'autenticador desligado',
  'unsupported-method': 'método de autenticação não suportado',
  disabled: 'login OTP desligado',
}
